import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "../../data/landing";
import { SectionEyebrow } from "./Primitives";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const total = TESTIMONIALS.length;

  return (
    <section className="relative py-20 lg:py-28">
      <div className="max-w-[1600px] w-full mx-auto px-4 sm:px-6 md:px-10 lg:px-12">
        <div className="text-center max-w-4xl lg:max-w-5xl mx-auto">
          <SectionEyebrow>Testimonials</SectionEyebrow>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900">
            Loved by founders & funds alike.
          </h2>
        </div>

        <div className="mt-14 relative max-w-5xl lg:max-w-6xl mx-auto">
          <AnimatePresence mode="wait">
            {TESTIMONIALS.map((t, i) =>
              i === idx ? (
                <motion.div
                  key={t.name}
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -16 }}
                  transition={{ duration: 0.4 }}
                  className="glass rounded-3xl p-8 md:p-12 text-center border border-gray-100/70 shadow-lg hover:shadow-xl transition-all duration-300"
                  data-testid={`testimonial-${i}`}
                >
                  <div className="flex justify-center gap-1 mb-5">
                    {Array.from({ length: t.rating }).map((_, k) => (
                      <Star key={k} className="w-5 h-5 fill-[#F59E0B] text-[#F59E0B]" />
                    ))}
                  </div>
                  <p className="font-display text-xl md:text-2xl text-gray-900 leading-snug tracking-tight">
                    &ldquo;{t.quote}&rdquo;
                  </p>
                  <div className="mt-7 flex items-center justify-center gap-3">
                    <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover ring-2 ring-white shadow" />
                    <div className="text-left">
                      <p className="text-sm font-semibold text-gray-900">{t.name}</p>
                      <p className="text-xs text-gray-500">{t.role}</p>
                    </div>
                  </div>
                </motion.div>
              ) : null
            )}
          </AnimatePresence>

          <div className="mt-6 flex items-center justify-center gap-2">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className={`h-2 rounded-full transition-all ${i === idx ? "w-8 bg-gradient-to-r from-[#7C3AED] to-[#EC4899]" : "w-2 bg-gray-200"}`}
                data-testid={`testimonial-dot-${i}`}
                aria-label={`Go to testimonial ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
